<app-banner-card
  [header]="'pages.customers.banner.title' | translate"
  [addButtonConfiguration]="addButtonConfiguration()"
  [breadcrumbs]="breadcrumbs"
>
  <div class="mt-16">
    <app-customers-kpi-cards />
  </div>
</app-banner-card>
